import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import Logger from 'core/utils/Logger'

import { fetchMdfActivities, syncMdfActivities } from '../../api'
import { setMdfActivitiesLastSyncTime } from '../../lib'
import { selectIsMdfActivitiesFetching } from '../selectors'

export const requestMdfActivitiesData = createAsyncThunk(
  'mdfActivities/requestMdfActivitiesData',
  async ({
    partnerId,
    fYear,
    programType,
    syncBeforeLoad = true,
  }: {
    partnerId: string
    fYear: number
    programType: ProgramTypes
    syncBeforeLoad?: boolean
  }) => {
    if (syncBeforeLoad) {
      try {
        await syncMdfActivities({ partnerId, fYear })
        try {
          setMdfActivitiesLastSyncTime({ partnerId, fYear, syncTime: Date.now() })
        } catch (storageError: unknown) {
          Logger.error('Failed to save the MDF activities sync time.', storageError)
        }
      } catch (error: unknown) {
        Logger.error('Failed to sync MDF activities. Loading existing MDF activities data.', error)
      }
    }

    return fetchMdfActivities({ partnerId, fYear, programType })
  },
  {
    condition: (_, { getState }) => {
      const isMdfActivitiesFetching = compose(selectIsMdfActivitiesFetching, getState)()
      return !isMdfActivitiesFetching
    },
  }
)
